import { Theme } from '@mui/material';
import { darken } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.background.main,
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
  studentInfoContainer: {
    maxWidth: '1280px',
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    marginBottom: '30px',
    borderBottom: '1px solid #E0E0E0',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '20px',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  tabsContainer: {
    display: 'flex',
    gap: '8px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  tabButton: {
    width: 'clamp(91px, 11.82vw, 242px)',
    height: 'clamp(24px, 3.13vw, 64px)',
    borderRadius: '5px 5px 0 0',
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 'clamp(6px, 0.83vw, 17px)',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '17px 9px',
      height: '54px',
      borderRadius: '5px 5px 0 0',
      fontSize: '15px',
    },
  },
  enrollmentHeaderContentContainer: {
    width: '100%',
    maxWidth: '891px',
    '& .enrollment-select': {
      width: '100%',
      maxWidth: '359px',
      '& .MuiSelect-select': {
        fontSize: '16px',
        fontWeight: 700,
      },
    },
  },
  tabButtonActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.9,
    },
  },
  tabButtonInactive: {
    backgroundColor: theme.palette.background.gray,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.background.gray,
      opacity: 0.9,
    },
  },
  tabButtonIcon: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
      gap: '30px',
      alignItems: 'stretch',
    },
  },
  attributeContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '21px',
    [theme.breakpoints.between('md', 'lg')]: {
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '16px',
    },
  },
  attributeItem: {
    flex: '0 0 226px',
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    maxWidth: '300px',
  },
  HeaderText: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    paddingBottom: '10px',
    [theme.breakpoints.down('md')]: {
      alignSelf: 'start',
      fontSize: '20px',
      paddingBottom: '0px',
    },
  },
  backButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
    alignSelf: 'end',
    paddingBottom: '10px',
  },
  backButton: {
    padding: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  backIcon: {
    color: theme.palette.primary.red || '#E94745',
    fontSize: 'clamp(12px, 1.60vw, 34px)',
    fontWeight: 700,
  },
  studentName: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  contentHeaderRowMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  arrowIconButton: {
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
    },
  },
  textTitle: {
    fontSize: '20px',
    fontWeight: 700,
    color: '#5BC2D5',
  },
  contentHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  samePersonButton: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontWeight: 600,
  },
  textSubtitle: {
    fontSize: '20px',
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
    fontWeight: 700,
    textAlign: 'center',
  },
  textContent: {
    fontSize: '20px',
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  textContentDirect: {
    fontSize: '20px',
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
    lineHeight: '1.5',
    textAlign: 'left',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    gap: '20px',
    boxShadow: '0px 0px 4px 0px #00000040',
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '400px',
      height: '100%',
    },
  },
  attributePair: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
  },
  attributeTitle: {
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  attributeValue: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
    wordBreak: 'break-word',
  },
  textContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: '50px',
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '30px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'start',
    },
  },
  editButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '20px',
    width: '100%',
  },
  finishButton: {
    width: '400px',
    height: '50px',
    borderRadius: '5px',
    fontFamily: 'Montserrat',
    fontSize: 'clamp(16px, 1.04vw, 20px)',
    padding: '0px 22px',
    fontWeight: 600,
    color: theme.palette.primary.white,
    backgroundColor: theme.palette.primary.red,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: darken(theme.palette.primary.red ?? '#000000', 0.2),
    },
  },
  editButton: {
    width: 'clamp(200px, 11.82vw, 227px)',
    height: '50px',
    borderRadius: '5px',
    fontFamily: 'Montserrat',
    fontSize: 'clamp(16px, 1.04vw, 20px)',
    fontWeight: 600,
    padding: '0px',
    color: theme.palette.primary.white,
    backgroundColor: theme.palette.primary.red,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: darken(theme.palette.primary.red ?? '#000000', 0.2),
    },
  },
  leadSourceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: '40px',
      alignItems: 'center',
    },
  },
  successButton: {
    backgroundColor: '#4CAF50',
    '&:hover': {
      backgroundColor: darken('#4CAF50', 0.2),
    },
  },
  pendingDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#E94745',
    marginLeft: '5px',
    marginTop: '2px',
  },
}));

export default useStyles;
